type MdastNode = {
  type: string;
  value?: string;
  children?: MdastNode[];
};

export function remarkEscapeRawHtml() {
  return (tree: MdastNode) => {
    walkMdast(tree, (node, index, parent) => {
      if (
        node.type !== 'html' ||
        parent?.children === undefined ||
        index === undefined
      ) {
        return;
      }

      parent.children[index] = {
        type: 'text',
        value: node.value ?? '',
      };
    });
  };
}

function walkMdast(
  node: MdastNode,
  visit: (
    node: MdastNode,
    index: number | undefined,
    parent: MdastNode | undefined,
  ) => void,
  parent?: MdastNode,
  index?: number,
): void {
  visit(node, index, parent);

  if (!Array.isArray(node.children)) {
    return;
  }

  for (const [childIndex, child] of node.children.entries()) {
    walkMdast(child, visit, node, childIndex);
  }
}
